import gql from "graphql-tag";
import {client} from "./client";
import {CreateLayer} from "../../schema/CreateLayer";
import {FetchResult, Mutation} from "../../types";

const getMutation = (patchObject: {[key: string]: any}): any => ({
    variables: {input: {layer: patchObject}},
    mutation: gql`${CreateLayer}`
});

export async function createLayer (layerObject: {[key: string]: any}) {
    const result: FetchResult<Mutation> = await client.mutate(getMutation(layerObject));
    const layer = result.data?.createLayer?.layer;
    if (!layer) {
        throw new Error('failed to create layer');
    } else {
        await client.cache.reset();
        return layer;
    }
}
